import React from 'react'

import { DeliveryInstructions } from 'DeliveryInstructions/DeliveryInstructions'
import { DeliveryTips } from 'DeliveryTips/DeliveryTips'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { RibbonTriggerContainer } from 'components/RibbonTrigger'
import { Calendar } from 'routes/Signup/Components/Calendar/Calendar'
import { DeliveryDay } from 'routes/Signup/Components/Calendar/models/DeliveryDay'
import {
  getDeliveryDetailsInstructions,
  getIsValidDeliveryDetailsInstructionsCustom,
} from 'selectors/deliveryDetails'

import { Button } from '../../Button'

import signupCss from '../../Signup.css'
import css from './DeliveryStep.css'

type DeliveryStepWithCalendarProps = {
  deliveryDays: DeliveryDay[]
  tempDate: string
  onTempDateChange: (date: string) => void
  dateLabel: string
  onShowRecipe: () => void
}

export const DeliveryStepWithCalendar = ({
  deliveryDays,
  tempDate,
  onTempDateChange,
  dateLabel,
  onShowRecipe,
}: DeliveryStepWithCalendarProps) => {
  const deliveryInstructions = useSelector(getDeliveryDetailsInstructions)
  const isValidDeliveryDetailsInstructionsCustom = useSelector(
    getIsValidDeliveryDetailsInstructionsCustom,
  )

  let ctaDisabled
  if (!deliveryInstructions) {
    ctaDisabled = true
  } else {
    ctaDisabled = !isValidDeliveryDetailsInstructionsCustom
  }

  return (
    <>
      <div className={css.calendarContainer}>
        <div data-testing="signupDeliveryDay" data-testid="signupDeliveryDay">
          <Calendar
            deliveryDays={deliveryDays}
            selectedDay={tempDate}
            onDayChange={onTempDateChange}
          />
        </div>
        <>
          <DeliveryInstructions />
          <DeliveryTips />
        </>
      </div>
      <div className={signupCss.footer}>
        <div className={classNames(signupCss.inputContainer, css.confirmButton)}>
          <Button
            data-testing="signupDeliveryCTA"
            data-testid="signupDeliveryCTA"
            width="full"
            onClick={onShowRecipe}
            disabled={ctaDisabled}
          >
            {`Select ${dateLabel}`}
          </Button>
        </div>
      </div>
      <RibbonTriggerContainer name="wizard-delivery-options" />
    </>
  )
}
